<template>
  <div>
    <form role="form" name="myForm" @submit.prevent="ResetPassword" novalidate>
      <div
        class="box"
        style="margin-top:55px;"
        data-ng-hide="expiredLinkMessage != ''"
      >
        <header class="head">
          <div align="center">
            <img style="margin-top:-80px;" src="../../assets/imgs/logo.png" />
          </div>
          <h1>Reset Your Password</h1>
        </header>
        <input
          type="text"
          class="resetpassword-email"
          :class="{
            'input-validation-error':
              EmailFlags.invalid && !EmailFlags.pristine,
          }"
          name="Email"
          placeholder="Email Address"
          style="margin-left:30px;"
          v-model="Email"
          v-validate="'required|email'"
          autocomplete="off"
          autofocus
        />
        <span
          class="text-danger"
          style="margin-left:30px;"
          v-if="errors.first('Email')"
          >{{ errors.first("Email") }}</span
        >

        <input
          type="password"
          class="resetpassword-password"
          :class="{
            'input-validation-error':
              (PasswordFlags.invalid && !PasswordFlags.pristine) ||
              errors.has('Password'),
          }"
          name="Password"
          placeholder="Password"
          v-model="Password"
          style="margin-left:30px;"
          ref="pass"
          v-validate="'required|min:8|strong_password'"
          data-vv-validate-on="blur"
        />

        <span
          class="text-danger"
          style="margin-left:30px;padding:10px"
          v-if="errors.first('Password')"
          >{{ errors.first("Password") }}</span
        >
        <input
          type="password"
          class="resetpassword-password"
          v-validate="'required|confirmed:pass'"
          :class="{
            'input-validation-error':
              (ConfirmPasswordFlags.invalid &&
                !ConfirmPasswordFlags.pristine) ||
              errors.has('ConfirmPassword'),
          }"
          name="ConfirmPassword"
          placeholder="Confirm Password"
          data-vv-validate-on="blur"
          v-model="ConfirmPassword"
          style="margin-left:30px;"
          data-vv-as="Confirm Password"
          required
        />
        <span
          class="text-danger"
          v-if="errors.first('ConfirmPassword')"
          style="margin-left:30px;"
          >{{ errors.first("ConfirmPassword") }}</span
        >
        <div>
          <div
            v-bind:id="'g_recaptcha'"
            class="g-recaptcha"
            style="align-items: center;"
          ></div>
        </div>
        <span
          class="text-danger"
          style="margin-left:30px;"
          v-if="errors.first('CAPTCHA')"
          >{{ errors.first("CAPTCHA") }}</span
        >
        <br />
        <div class="row">
          <div class="col-md-8" style="margin-left:30px;">
            <input type="submit" class="login-button" value="Reset" />
            <input
              type="button"
              class="login-button"
              style="margin-left:5px;"
              @click="GoBack"
              value="back To Login"
            />
            <loading v-if="loading"></loading>
          </div>
        </div>
        <br />
        <div
          v-if="errorMessage != '' && errorMessage != null"
          class="alert alert-danger text-center"
        >
          <strong>{{ errorMessage }}</strong>
        </div>
      </div>
    </form>
    <div
      v-if="expiredLinkMessage != '' && expiredLinkMessage != null"
      class="alert alert-danger text-center"
    >
      <strong>{{ expiredLinkMessage }}</strong>
    </div>
    <div
      v-if="successMessage != '' && successMessage != null"
      class="alert alert-success text-center"
    >
      <strong>{{ successMessage }}</strong>
    </div>
  </div>
</template>

<style>
.g-recaptcha {
  display: inline-block;
  align-content: center;
  padding-left: 18%;
  margin-bottom: 15px;
}
</style>
<script>
import { mapGetters, mapState } from "vuex";
import { mapFields } from "vee-validate";
import * as ACTIONS from "../../store/actions";
import VeeValidate, { Validator } from "vee-validate";

export default {
  data() {
    return {
      successMessage: "",
      expiredLinkMessage: null,
      error: null,
      Token: null,
      Password: null,
      ConfirmPassword: null,
      Email: null,
    };
  },
  methods: {
    GoBack() {
      this.$router.push("/Login");
    },
    ResetPassword() {
      // var vm = this;
      debugger;
      this.$validator.errors.remove("CAPTCHA");
      var response = grecaptcha.getResponse();
      if (response == null || response == "") {
        this.$validator.errors.add({
          field: "CAPTCHA",
          msg: "Please verify captcha",
        });
        this.$validator.validateAll().then((res) => {
          if (res) {
          }
        });
        return;
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          var vm = this;
          var _token = this.Token;
          var params = new URLSearchParams();
          params.append("Email", this.Email);
          params.append("Password", this.Password);
          params.append("Token", _token);
          //var response = grecaptcha.getResponse();
          params.append("Captcha", response);
          this.$store
            .dispatch(ACTIONS.RESET_PASSWORD, params)
            .then((res) => {
              var { data } = res;
              if (data && data.StatusCode == 200) {
                vm.successMessage = data.StatusMessage;
                setTimeout(() => {
                  vm.successMessage = null;
                  vm.$router.push("/Login");
                }, 1800);
              } else if (data && data.StatusCode == 450) {
                var { ResponseData } = data;
                if (ResponseData) {
                  for (var prop in ResponseData) {
                    vm.$validator.errors.add({
                      field: prop,
                      msg: ResponseData[prop],
                    });
                  }
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.error = " Please Provide correct details";
          var vm = this;
          setTimeout(() => {
            vm.error = "";
          }, 2200);
        }
      });
    },
    checkResetLinkValidity() {
      //var tolen = this.Token;
      var query = "?token=" + this.Token;
      var vm = this;
      this.$store
        .dispatch(ACTIONS.CHECK_LINK_AVAILABLE, query)
        .then((res) => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            vm.expiredLinkMessage = data.StatusMessage;
          } else {
            vm.expiredLinkMessage = "";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    this.Token = this.$route.params.ResetToken;
    this.checkResetLinkValidity();
  },
  mounted() {
    var key = this.SiteKey; //"6LfpNtQUAAAAAAB6dBaJ9c-8NsSwKYIbZ0-LfDI5";
    var d = document.getElementById("g_recaptcha");
    grecaptcha.render("g_recaptcha", {
      sitekey: key,
    });
    //  }, 600);
  },
  computed: {
    ...mapGetters({
      loading: "GETRESETLOADING",
      errorMessage: "GETRESETERRORMESSAGE",
      UserId: "GETRESETPASSWORDUSERID",
      SiteKey: "GetSiteKey",
    }),
    ...mapFields({
      EmailFlags: "Email",
      PasswordFlags: "Passowrd",
      ConfirmPasswordFlags: "ConfirmPassword",
    }),
  },
  created() {
    var vm = this;
    VeeValidate.Validator.extend("email-validate", {
      validate: function(value, obj) {
        if (value) {
          var Senddata = { id: vm.UserId, value: value };
          return vm.$store
            .dispatch(ACTIONS.DUPLICATE_EMAIL_RESET_PASSWORD, Senddata)
            .then((res) => {
              return { valid: res.data };
            })
            .catch((err) => {
              return { valid: true };
            });
        }
      },
      getMessage: function(field, params, value) {
        return "Duplicate email";
      },
    });
  },
};
</script>
